import React, { useState, useEffect } from "react";

import UserService from "../services/user.service";

const BoardModerator = () => {
  const [content, setContent] = useState("");

  useEffect(() => {
    UserService.getModeratorBoard().then(
      (response) => {
        setContent(response.data);
      },
      (error) => {
        const _content =
          (error.response &&
            error.response.data &&
            error.response.data.message) ||
          error.message ||
          error.toString();

        setContent(_content);
      }
    );
  }, []);

  return (
      <div className="headDiv">
        <div className="bg-light p-5 rounded-lg m-3">
          <h3>{content}</h3>
        </div>
    </div>
  );
};

export default BoardModerator;
